// extracted by mini-css-extract-plugin
module.exports = {"story-container":"story-m__story-container__2J8bp"};